module.exports = __webpack_public_path__ + "static/media/140.6f99cbee.png";